<!----------------------------------------------- version 1  ------------------------------------>
<div *ngIf="version === 1">
    <input
        *ngIf="!readOnly"
        type="{{ type }}" 
        class="w-full bg-white border border-gray-300 flex-1 px-3 py-2 text-sm bg-gray-50 rounded-lg 
        "
        [ngClass]="{
            'bg-gray-300 bg-opacity-50 text-gray-400': disabled && !readOnly,
            'focus:outline-none ': !disabled && readOnly,
            'bg-white my-theme-custom-input-color focus:outline-none': !disabled && !readOnly,
        }" 
        [placeholder]="placeholder"
        [(ngModel)]="valueIn"
        (ngModelChange)="onChangeInput($event)"     
        [disabled]="disabled"    
        max="{{ type === 'number' ? max : false }}"
        min="{{ type === 'number' ? min : false }}"
        maxlength="{{ type === 'text' ? max : false }}"
        minlength="{{ type === 'text' ? min : false }}"
    />
    <!-- แจ้งเตือน -->
    <p class="text-red-600 text-xs mt-1" 
        *ngIf="validateIn.where === validateName && validateIn.result && !disabledValidate"
    >
        {{
            validateType === 'text' ? "กรุณากรอกข้อความให้ถูกต้อง" 
            : validateType === 'number' ? "กรุณากรอกตัวเลขให้ถูกต้อง" 
            : "กรุณากรอกตัวอักษรให้ถูกต้อง ห้ามใส่ตัวพิเศษ เช่น # $ % ^ & * "
        }}
    </p>
    <!-- อ่านเท่านั้น -->
    <div *ngIf="readOnly">
        <div class="text-gray-600 p-2 h-10 rounded-lg border border-gray-300">
            <p>
                {{  
                    (type === 'number' ? (valueIn | number: format !== '' ? format : '1.0-0') 
                    : (type === 'date' ? (valueIn | date: format !== '' ? format : 'dd/MM/yyyy') 
                    : valueIn))
                }}</p>
        </div>
    </div>
    
</div>

<!----------------------------------------------- version 2  ------------------------------------>
<div *ngIf="version === 2">
    <div class="relative">
        <input
            *ngIf="!readOnly"
            type="{{ type }}" 
            class="w-full bg-white border rounded-lg border-gray-300 flex-1 px-3 py-2 text-sm bg-gray-50 my-theme-custom-animation-input relative 
            "
            [ngClass]="{
                'bg-gray-300 bg-opacity-50 text-gray-400': disabled && !readOnly,
                'focus:outline-none ': !disabled && readOnly,
                'bg-white my-theme-custom-input-color focus:outline-none': !disabled && !readOnly,
            }"  
            [(ngModel)]="valueIn"
            (ngModelChange)="onChangeInput($event)"     
            [disabled]="disabled"
            
            max="{{ type === 'number' ? max : false }}"
            min="{{ type === 'number' ? min : false }}"
            maxlength="{{ type === 'text' ? max : false }}"
            minlength="{{ type === 'text' ? min : false }}"
        />
        <label class="absolute top-0 left-0 px-3 py-2 text-sm text-gray-800 my-theme-custom-animation-input-text"
        >{{ placeholder }}</label>
    </div>
    <!-- แจ้งเตือน -->
    <p class="text-red-600 text-xs mt-1" 
        *ngIf="validateIn.where === validateName && validateIn.result && !disabledValidate"
    >
        {{
            validateType === 'text' ? "กรุณากรอกข้อความให้ถูกต้อง"             
            : validateType === 'number' ? "กรุณากรอกตัวเลขให้ถูกต้อง" 
            : "กรุณากรอกตัวอักษรให้ถูกต้อง ห้ามใส่ตัวพิเศษ เช่น # $ % ^ & * "
        }}
    </p>

    <div *ngIf="readOnly">
        <div class="text-gray-600 p-2 h-10 bg-gray-50 rounded-lg border border-gray-300">
            <p>
                {{  
                    (type === 'number' ? (valueIn | number: format !== '' ? format : '1.0-0') 
                    : (type === 'date' ? (valueIn | date: format !== '' ? format : 'dd/MM/yyyy') 
                    : valueIn))
                }}</p>
        </div>
    </div>
</div>
